const comments = [
  {
    name: '影迷小王',
    text: '51影视真的太良心了！高清不卡顿，看《狂飙》全集一点都不缓冲，比那些收费平台还流畅。每天下班回家第一件事就是打开51影视追剧，已经推荐给身边所有朋友了！',
    tag: '忠实用户',
    rating: 5,
  },
  {
    name: '追剧达人阿琳',
    text: '找了好久才找到这个免费看剧的好平台，片库真的超级全！最近在追的《长相思》和《莲花楼》这里都有，画质清晰流畅不卡顿，而且更新速度也很快，强烈推荐！',
    tag: '活跃观众',
    rating: 5,
  },
  {
    name: '老李看电影',
    text: '作为一个电影爱好者，51影视的院线大片专区简直是我的天堂。周末在家就能免费看最新电影，高清画质配合家里的投影仪，观影体验不输影院。关键是完全免费，太赞了！',
    tag: '资深影迷',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              观众热评
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              听听他们怎么说
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {comments.map((comment) => (
              <div
                key={comment.name}
                className="bg-background-50 rounded-xl p-6 border border-background-200/70"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  &ldquo;{comment.text}&rdquo;
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                    <span className="text-xs font-bold text-primary-600">
                      {comment.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                      {comment.tag}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}